// src/components/CompanyVotePanel.jsx
import React, { useEffect, useState } from "react";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import "./CompanyVotePanel.css";
import { getAuth } from "firebase/auth";

export default function CompanyVotePanel({ ticker }) {
  const [voteResults, setVoteResults] = useState(null);
  const [loadingVotes, setLoadingVotes] = useState(false);
  const [error, setError] = useState(null);

  const db = getFirestore();

  useEffect(() => {
    if (!ticker) return;

    const fetchVotes = async () => {
      setLoadingVotes(true);
      setError(null);

      try {
        const voteDocRef = doc(db, "Votes", ticker);
        const voteDocSnap = await getDoc(voteDocRef);

        if (!voteDocSnap.exists()) {
          setVoteResults(null);
          return;
        }

        const auth = getAuth();
        const user = auth.currentUser;

        if (!user) throw new Error("Not signed in");

        const token = await user.getIdToken();
        const response = await fetch(
          "https://getcompanyvotes-5dhfwyjvzq-uc.a.run.app",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ ticker }),
          }
        );

        if (!response.ok) {
          throw new Error(`Vote API error: ${response.status}`);
        }

        const data = await response.json();
        setVoteResults(data);
      } catch (err) {
        console.error("Error fetching company votes:", err);
        setError("Failed to load vote status.");
      } finally {
        setLoadingVotes(false);
      }
    };

    fetchVotes();
  }, [ticker, db]);

  if (loadingVotes) return null;
  if (error) return <p className="error">{error}</p>;
  if (!voteResults) return null;

  return (
    <div className="vote-results" style={{ position: 'relative', fontFamily: "'JetBrains Mono', monospace" }}>
      <h3 style={{ margin: '0 0 10px 0', fontSize: '0.8rem', color: '#50e3c2', textTransform: 'uppercase' }}>
        Vote In Progress
      </h3>

      <div className="vote-data-header" style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        marginBottom: '6px'
      }}>
        <span className="label-yea" style={{ color: '#50e3c2', fontSize: '0.65rem', fontWeight: 'bold' }}>
          YEA: {voteResults.Yea}%
        </span>
        <span className="label-nay" style={{ color: '#ff7b72', fontSize: '0.65rem', fontWeight: 'bold' }}>
          {voteResults.Nay}% :NAY
        </span>
      </div>

      <div className="vote-progress">
        <div
          className="vote-bar yea-bar"
          style={{ width: `${voteResults.Yea}%` }}
        />
        <div
          className="vote-bar nay-bar"
          style={{ width: `${voteResults.Nay}%` }}
        />
      </div>

      {/* System Footer with Initiator Info */}
      <div style={{ marginTop: '10px', textAlign: 'right' }}>
        <p style={{ fontSize: '0.55rem', color: '#888', margin: '0', textTransform: 'uppercase' }}>
          Initiated By: <span style={{ color: '#eee' }}>{voteResults.initiatorDisplayName || "Unknown"}</span>
        </p>
        <p style={{ 
          fontSize: '0.55rem', 
          color: '#555', 
          margin: '2px 0 0 0',
          letterSpacing: '1px' 
        }}>
          EXPIRY: {voteResults.expiry}
        </p>
      </div>
    </div>
  );
}